module.exports = __webpack_public_path__ + "img/uk-pregnancy-childbirth-and-the-puerperium-female.145ddb72.png";